newFunction();

function newFunction() {
  (function ($) {
    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);
    if (isIE11) {
      $('body').addClass('is-ie-11');
    }

    function fixWebkitHeightBug() {
      var svgW = 959;
      var svgH = 593;
      var curSVGW = $('#map_container').width();
      var newSVGH = heightInRatio(svgH, svgW, curSVGW);
      $('#map_container').height(newSVGH);

      function heightInRatio(oH, oW, nW) {
        return (oH / oW * nW);
      }
    }
    $(window).resize(function () {
      fixWebkitHeightBug();
    });
    $(function () {
      //Responsive nav
      var $menu = $('.nav'),
        $menulink = $('.menu-link');
      $menulink.click(function () {
        $menulink.toggleClass('active');
        $menu.delay(150).slideToggle(0);
        return false;
      });
    });
  })(jQuery);
}
